import * as React from "react";
import { useEffect, useState } from "react";
import {
    FrontEndPoints,
    getDefaultImage,
    getEmailFromToken,
    imageType,
    openNotificationWithIcon,
} from "../../shared/Common";
import "./EqSchoolDashboard.scss";
import { Row, Col, Avatar } from "antd";
import { useTranslation } from "react-i18next";

import {
    EqDisciplineType,
    EqMessageType,
    eqNotificationTypes,
    EqTrainingType,
    ProductType,
} from "../../shared/enums";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Api from "../../shared/Api";
import {
    GetEventMessage,
    ApiEndpoints,
    ValidateIsSchool,
} from "../../shared/Common";

import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../context/Context";
import { IEqEventData, IEqUiEventInvite } from "../../shared/interfaces/IEqEventDto";
import { IEventType, IGetSchoolTrainingDto, IUpdateProductDto } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { ISelectProps } from "../../shared/Interfaces";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import { IUnpaidOrdersDto } from "../../shared/general/IUnpaidOrders";
import { Modal, Spin } from "antd-v5";
import EqSendMessageModal from "../../eqTrainer/eqMessageBoard/eqSendMessageModal/EqSendMessageModal";
import UpcomingActDashboard from "../../eqStudent/UpcomingActDashboard/UpcomingActDashboard";
import HorseUpcomingAct from "../../eqTrainer/TrainerHorseActivity/TrainerHorseActivity";
import SchoolDashboardInvitations from "../SchoolDashboardInvitations/SchoolDashboardInvitations";
import EqDashboardCalendar from "../../custom/eqDashBoardCalendar/EqDashboardCalendar";
import { CourseUI } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { ISchoolStudents, ITrainerOption } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { IEqUiSelectModel, IGetPopulation } from "../../shared/interfaces/ILocationDto";
import { ICreateEventDto } from "../../shared/interfaces/ICreateEventDto";
import { IEqPublicEvent } from "../../shared/interfaces/GetSchoolTrainingInfoDto";
import { GetSchoolStudentsDto, IEarningsResultDto, IUpcomingActivitiesResultDto } from "../../shared/interfaces/schoolTraining/school";
import { IEqTrainers } from "../../eqAdmin/eqApproveTrainer/EqApproveTrainer";
import UnpaidOrdersModalSchool from "../UnpaidOrdersModalSchool/UnpaidOrdersModalSchool";
import EarningsStats from "../../EarningStats/EarningsStats";


const EqSchoolDashboard = (props: any) => {
    const userDetails: any = useAuthState();
    const [loading, setLoading] = useState(false);
    const [unpaidOrders, setUnpaidOrders] = React.useState<IUnpaidOrdersDto[]>();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
    const [selectedEmail, setSelectedEmail] = React.useState<string>("");

    const handleClose = () => {
        setIsModalOpen(false);
    };
    const currentUserEmail = getEmailFromToken();

    const [reminderText, setReminderText] = useState({
        heading: "",
        subject: "",
        message: "",
        senderEmail: currentUserEmail,
        messageType: EqMessageType.Notification,
        recipientEmails: [] as any,
    });

    const isSchool: boolean = ValidateIsSchool(userDetails);
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [isError, setIsError] = React.useState(false);
    const [message, setMessage] = React.useState("");

    // school Trainings
    //NO USE
    const [showEventList, setShowEventList] = React.useState(true);
    const [trainingsList, setTrainingsList] = React.useState < IGetSchoolTrainingDto[]>([])
    const [areas, setAreas] = React.useState<IEqUiSelectModel[]>([]);
    //NO USE
    const [trainersList, setTrainersList] = React.useState<Array<IEqTrainers>>([]);
    const [trainersOptions, setTrainersOptions] = useState<ITrainerOption[]>([]);
    const [productOptions, setProductOptions] = React.useState<any>({
        createOptions: [],
        editOptions: [],
    });
    const [products, setProducts] = React.useState<IUpdateProductDto[]>([]);

    const [weekDays, setWeekDays] = React.useState<IEqUiSelectModel[]>([]);
    const [eventTypes, setEventTypes] = React.useState<IEventType[]>([]);

    const [population, setPopulation] = React.useState<IGetPopulation[]>([]);
    const [schoolStudents, setSchoolStudents] = useState<ISchoolStudents[]>([]);
    const [groupPopulation, setGroupPopulation] = React.useState<IGetPopulation[]>([]);
    const [studentHorsesList, setStudentHorsesList] = React.useState<GetSchoolStudentsDto[]>([])

    // events
    const [eventsList, setEventsList] = React.useState<ICreateEventDto[]>([]) as any;

    const [courseList, setCourseList] = React.useState<CourseUI[] | null>(null);

    const [schoolTrainings, setSchoolTrainings] = React.useState < IGetSchoolTrainingDto[]>([])
    const [schoolEvents, setSchoolEvents] = React.useState < IEqPublicEvent[]>([]);
    const [schoolEarnings, setSchoolEarnings] = React.useState<IEarningsResultDto>() as any;
  const [horsesList, setHorsesList] = React.useState([] as any);
    const [upcomingActivities, setUpcomingActivities] = React.useState<IUpcomingActivitiesResultDto[]>([]);

    const [trainingInvites, setPendingTrainingInvites] = React.useState<IEqUiEventInvite[]>([])
    //NO USE
    const [courseInvites, setCourseInvites] = React.useState([] as any);
  
  //NO USE
  const [stateView, setStateView] = useState({
    unpaidTraining: [],
    pendingTraining: [],
    unpaidProduct: [],
    pendingProduct: [],
    upcomingTraining: [],
    monthlySales: []
  });


    
    const [selectedTraining, setSelectedTraining] = React.useState < IGetSchoolTrainingDto[]>([])
    const [trainingOptions, setTrainingOptions] = React.useState<IEventType[]>([]);

    const [selectedEvents, setSelectedEvents] = React.useState<IGetSchoolTrainingDto[]>([])
    const [eventsOptions, setEventsOptions] = React.useState<IEventType[]>([]);

  const [fromDate, setFromDate] = useState<moment.Moment | null>(null);

  //
  var selectedMessages = new Array<any>();
  const [misCheckAll, msetIsCheckAll] = useState(false);

    const [messageString, setMessageString] = useState("");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTime = today.getTime();

    useEffect(() => {
        //------------//

        fetchSchoolEarnings();

        GetAllCourseJoinRequestsByStudents();
        GetAllTrainingJoinRequestsByStudents();

        fetchUnpaidOrders();
        SchoolGetUpcomingActivities();
        fetchHorseListWithTasksAndTrainings();
        //Requests
        fetchUserCourses();
        GetSchoolEventsByMonth();
        GetSchoolTrainingByMonth();

        //------------//

        // GetAllSchoolTrainingsByWithLessons();

        // dashboardState();

        // createTrainingList();
        // createEventList();
        // GetSchoolTrainers();
        // GetSchoolStudents();
        // createEventTypes();
        // getWeekDays();
        // GetProductList();
        // getAreas();
        // getPopulation();
        // getGroupPopulation();
        // GetTrainerPublicEvents();
    }, []);

    const fetchUserCourses = async (isStudent: boolean = false) => {
        const path = isStudent ? ApiEndpoints.Course.GetStudentAll : ApiEndpoints.Course.GetAll;
        try {
            const response = await Api.get(path);
            if (response.status === 200) {
                const sortedCourses = response.data.sort(
                    (a: any, b: any) => b.createdDate - a.createdDate
                );
                setCourseList(sortedCourses);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const fetchSchoolEarnings = async () => {
        try {
            const response = await Api.get(ApiEndpoints.School.GetTotalEarnings);
            if (response.status === 200) {
                
                setSchoolEarnings(response.data);

                console.log("API response:", response.data);
            }
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const fetchHorseListWithTasksAndTrainings = async () => {
        try {
            const response = await Api.get(ApiEndpoints.GetAllHorses);
            if (response.status === 200) setHorsesList(response.data);
        } catch (error: any) {
            console.error("API error:", error.response?.data || error.toJSON?.() || error.message);
        }
    };

    const SchoolGetUpcomingActivities = async () => {
        try {
            const response = await Api.get(ApiEndpoints.School.GetUpcomingActivities);

            setUpcomingActivities(response.data);

            //   return response.data; // Return response data
        } catch (error) {
            console.error("Error fetching upcoming trainings:", error);
            throw error; // Rethrow error for handling in the component
        }
    };

    const GetSchoolEventsByMonth = () => {
        Api.get(ApiEndpoints.EqOwnerPublicEvent.GetAll)
            .then((response) => {
                if (response && response.status === 200) {
                    var data = response.data;
                    setSchoolEvents(data);
                } else {
                    setIsError(true);
                    GetEventMessage(response.status);
                }
            })
            .catch((error) => {
                GetEventMessage(error.response.status);
            });
    };
    const fetchUnpaidOrders = async () => {
        setLoading(true);
        try {
            const response = await Api.get(`${ApiEndpoints.School.GetUnpaidOrders}`);
            let data = response.data as IUnpaidOrdersDto[];

            setUnpaidOrders(data);
            if (data.length > 0) {
                showModal();
            }
        } catch (error) {
            console.error("fetchOrders", error);
        } finally {
            setLoading(false);
        }
    };

    const GetSchoolTrainingByMonth = () => {
        Api.get(ApiEndpoints.SchoolTrainingsOfMonths)
            .then((response) => {
                if (response && response.status === 200) {
                    var data = response.data;
                    setSchoolTrainings(data);

                    console.log("School training", data);
                } else {
                    setIsError(true);
                    GetEventMessage(response.status);
                }
            })
            .catch((error) => {
                GetEventMessage(error.response.status);
            });
    };

  //NO USE WE HAVE BEEN CREATED NEW STATS
    //stat
    const dashboardState = () => {

        Api.get(ApiEndpoints.GetSchoolDashboardState)
            .then((response) => {
                if (response && response.status === 200) {
                    // var result = response.data;
                    const { pendingProductInvites,
                        pendingTrainingInvites,
                        unPaidProductOrders,
                        unPaidTrainingOrders,
                        upcomingTrainings,
                        monthlySales
                    } =
                        response.data;
                    setStateView({
                        unpaidTraining: unPaidTrainingOrders,
                        pendingTraining: pendingTrainingInvites,
                        unpaidProduct: unPaidProductOrders,
                        pendingProduct: pendingProductInvites,
                        upcomingTraining: upcomingTrainings,
                        monthlySales: monthlySales
                    });
                    console.log("datsssssss", response.data)
                } else {
                    setIsError(true);
                    (GetEventMessage(response.status));
                }
            })
            .catch((error) => {
                (GetEventMessage(error.response.status));
            });
    };

    const GetAllTrainingJoinRequestsByStudents = async () => {
        setMessageString("");

        try {
            const response = await Api.get(
                ApiEndpoints.TrainingRequest.GetAllTrainingJoinRequestsByStudents
            );

        if (response && response.status === 200) {
            const data = response?.data ? response.data : [];
            setPendingTrainingInvites(data);

         
        }
    } catch (err) {
        console.error("Error fetching pending trainer event invites:", err);
    }
  };
// I THINK THIS FUNCTION IS NOT BEING USED ANYWGERE SO THATS WHY I DONOT HANDLE COURSE INVITES

    const GetAllCourseJoinRequestsByStudents = async () => {
        
        try {
            const response = await Api.get(ApiEndpoints.UserCourseRequest.GetAll);

            if (response && response.status === 200) {
                const data = response?.data ? response.data : [];
                setCourseInvites(data);
            }
        } catch (err) {
            console.error("Error fetching pending trainer event invites:", err);
        }
    };


    //---------------//
    //------> School Trainings

    const GetAllSchoolTrainingsByWithLessons = async () => {
        setMessage("");
        let path =
            ApiEndpoints.GetAllSchoolTrainingsWithLessons +
            `?ExcludeDisciple=${EqDisciplineType.Open}`;
        Api.get(path).then(
            (response) => {
                if (response && response.status == 200) {
                    var data = response.data ? [...response.data] : new Array<any>();
                    setTrainingsList(data);

                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const GetSchoolStudents = () => {
        Api.get(ApiEndpoints.GetSchoolStudents).then(
            (response) => {
                if (response && response.status == 200) {
                    var studentHorsesListOptions = [] as any;
                    var schoolStudents = response.data;
                    setIsError(false);
                    // console.log(userDetails);
                    setMessage("");
                    setSchoolStudents(response.data);
                    // console.log(schoolHorsesList);
                    [...schoolStudents].map((item: any) => {
                        let horseListObj = [] as any;

                        if (item.user.horses.length > 0) {
                            [...item.user.horses].map((h: any) => {
                                let horseObj = {
                                    key: h.id,
                                    value: h.name,
                                    label: h.name,
                                };
                                horseListObj.push(horseObj);
                            });
                        }
                        if (item.school.horses.length > 0) {
                            [...item.school.horses].map((h: any) => {
                                let horseObj = {
                                    key: h.id,
                                    value: h.name,
                                    label: h.name,
                                };
                                horseListObj.push(horseObj);
                            });
                        }

                        let studentHorsesObj = {
                            key: item.key,
                            horseList: horseListObj,
                        };

                        studentHorsesListOptions.push(studentHorsesObj);
                    });
                    setStudentHorsesList(studentHorsesListOptions);
                    console.log("studentHorses:", studentHorsesListOptions);
                    // console.log("TrainerStudents:",response.data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const getPopulation = () => {
        Api.get(ApiEndpoints.eventGetPopulation).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");
                    setPopulation(response.data);
                    // console.log("population:",response.data);
                    // console.table(response.data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const getGroupPopulation = () => {
        Api.get(ApiEndpoints.eventGetGroupPopulation).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");
                    setGroupPopulation(response.data);
                    //console.table(population);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const getAreas = () => {
        Api.get(ApiEndpoints.Location.GetUserAreaOptions).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");
                    setAreas(response.data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const GetSchoolTrainers = async () => {
        try {
            const response = await Api.get(ApiEndpoints.SchoolGetTrainers);

            if (response && response.status === 200) {
                const trainers = response.data;
                setTrainersList(trainers);


                const trainerObjList = [
                    {
                        key: userDetails.key,
                        value: userDetails.name,
                        label: userDetails.name,
                        icon: (
                            <Avatar
                                size={30}
                                src={
                                    userDetails.userImage
                                        ? userDetails.userImage.url
                                        : getDefaultImage(imageType.trainer)
                                }
                            />
                        ),
                    },
                    ...trainers.map((item: any) => ({
                        key: item.key,
                        value: item.firstName + item.lastName,
                        label: item.firstName,
                        icon: (
                            <Avatar
                                size={30}
                                src={
                                    item.userImage
                                        ? item.userImage.url
                                        : getDefaultImage(imageType.trainer)
                                }
                            />
                        ),
                    })),
                ];

                setTrainersOptions(trainerObjList);
            }
        } catch (error) {
            throw error;
        }
    };

    const GetProductList = () => {
        Api.get(ApiEndpoints.UserProduct).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");
                    let data = response.data;


                    var createProductOptions = [] as any;
                    var editProductOptions = [] as any;

                    if (data) {
                        var publicProducts = data?.filter(
                            (opt: any) => opt.type == ProductType.Public
                        );

                        publicProducts.map((item: any, Idx: any) => {
                            let obj = {
                                key: item.id,
                                value: item.title,
                                label: item.title,
                                limit: item.limit,
                            };
                            if (item.isUsed == false) {
                                createProductOptions.push(obj);
                            } else {
                                obj.value = obj.value + "- used";
                            }
                            editProductOptions.push(obj);
                        });

                        let obj = {
                            createOptions: createProductOptions,
                            editOptions: editProductOptions,
                        };
                        setProductOptions({ ...obj });
                        setProducts(publicProducts);
                    }
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const getWeekDays = () => {
        Api.get(ApiEndpoints.eventGetWeekDays).then(
            (response) => {
                if (response && response.status == 200) {
                    setIsError(false);
                    setMessage("");
                    setWeekDays(response.data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const createEventTypes = () => {
        var eventTypes = [];

        eventTypes.push({
            key: EqDisciplineType.Dressage,
            value: EqTrainingType[EqDisciplineType.Dressage],
        });
        eventTypes.push({
            key: EqDisciplineType.Jumping,
            value: EqTrainingType[EqDisciplineType.Jumping],
        });
        eventTypes.push({
            key: EqDisciplineType.Open,
            value: EqTrainingType[EqDisciplineType.Open],
        });
        eventTypes.push({
            key: EqDisciplineType.RidingCourse,
            value: EqDisciplineType[EqDisciplineType.RidingCourse],
        });

        setEventTypes(eventTypes);
    };

    // const handleOnUpdateTraining = (newData: any, oldData: any) => {
    //   if (trainingsList != undefined) {
    //     const trainings = [...trainingsList];
    //     var foundIndex = trainings.findIndex((x) => x.key == oldData.key);
    //     trainings[foundIndex] = newData;
    //     setTrainingsList(trainings);
    //   }
    // };

    const handleOnUpdateSchoolEvent = () => {
        GetSchoolEventsByMonth();
    };
    const handleOnUpdateSchoolTraining = () => {
        GetSchoolTrainingByMonth();
    };

    const editTraining = (data: IEqEventData) => {
        navigate(FrontEndPoints.trainer.createEvent, { state: data });
        // history.push({ pathname: FrontEndPoints.trainer.createEvent, });
        // history.push(FrontEndPoints.trainer.createEvent, { event: data });
    };
    const toggleEventList = () => {
        setShowEventList(!showEventList);
    };

    const removeTraining = (trainingData: IGetSchoolTrainingDto, refund?: boolean) => {


        let path =
            ApiEndpoints.SchoolTraining.Delete +
            `?key=${trainingData.key}&refund=${refund}`;
        Api.delete(path).then(
            (response) => {
                if (response && response.status == 200) {
                    removeItem(trainingData);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const removeItem = (data: any) => {
        if (trainingsList != undefined) {
            var updatedList =
                trainingsList != undefined
                    ? trainingsList.filter((item: any) => item.key !== data.key)
                    : new Array<any>();
            setSchoolTrainings(updatedList);

            trainingsList.map((item: any, index: number) => {
                item.display = index == 0 ? true : false;
            });
        }
    };

    //---------> Events

    const GetTrainerPublicEvents = async () => {
        let path = ApiEndpoints.GetTrainerEvents;

        Api.get(path).then(
            (response) => {
                if (response && response.status == 200) {
                    var data = response.data ? [...response.data] : new Array<any>();
                    setEventsList(data);
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };

    const handleOnUpdateEvent = (newData: any, oldData: any) => {

        GetSchoolEventsByMonth();
        // if (eventsList != undefined) {
        //   const events = [...eventsList];
        //   var foundIndex = events.findIndex(
        //     (x) => x.referenceKey == oldData.referenceKey
        //   );
        //   events[foundIndex] = newData;
        //   setEventsList(events);
        // }
    };
    const removeEvent = (data: IEqEventData, refund?: boolean) => {
        let path =
            ApiEndpoints.DeleteTrainerEvent +
            `?key=${data.key}&refund=${refund}`;
        Api.delete(path).then(
            (response) => {
                if (response && response.status == 200) {
                    removeEventItem(response.data);
                    GetTrainerPublicEvents();
                } else {
                    setIsError(true);
                    setMessage(GetEventMessage(response.status));
                }
            },
            (error) => {
                setIsError(true);
                setMessage(GetEventMessage(error.response.status));
            }
        );
    };
    const removeEventItem = (data: any) => {
        GetSchoolEventsByMonth();
        // if (eventsList != undefined) {
        //   var updatedList =
        //     eventsList != undefined
        //       ? eventsList.filter((item: any) => item.key !== data.key)
        //       : new Array<any>();
        //   setEventsList(updatedList);

        //   eventsList.map((item: any, index: number) => {
        //     item.display = index == 0 ? true : false;
        //   });
        // }
    };
    const GetStripeDashboardUrlAsync = () => {
        Api.get("Payment/GetAccountUrl").then(
            (response) => {
                if (response.status == 200) {
                    const data = response.data;
                    // window.location.href = data.url;
                    window.open(data.url, "_blank");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    //filter for training
    const filterTrainings = (trainingList: any[]) => {

        let filteredList = trainingList;
        if (selectedTraining && selectedTraining.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedTraining.some((selectedType: any) => item?.disciplineType === selectedType);
            }
            );
        }



        if (fromDate) {
            const FromDate = moment(fromDate).startOf("day").valueOf();
            filteredList = filteredList.filter((item) => {

                const startDate = moment(item?.startDate).startOf("day").valueOf();
                return startDate === FromDate;
            });
        }

        console.log(filteredList)
        return filteredList;
    }


    const trainingTypeProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("training"),
        extraHeight: true,
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedTraining ? selectedTraining : [],
        options: trainingOptions,
        changeFunc: (value: any) => {
            console.log(value);
            setSelectedTraining(value);
        },
    };
    const createTrainingList = () => {
        var eventTypes = [];
        eventTypes.push({
            key: EqDisciplineType.Dressage,
            value: EqTrainingType[EqTrainingType.PrivateLesson],
        });
        eventTypes.push({
            key: EqDisciplineType.Jumping,
            value: EqTrainingType[EqTrainingType.GroupLesson],
        });
        eventTypes.push({
            key: EqDisciplineType.Open,
            value: EqTrainingType[EqTrainingType.AvailableTimeSlots],
        });
        setTrainingOptions(eventTypes);
        console.log("options", trainingOptions);
    };


    const filterEvents = (eventList: any[]) => {

        let filteredList = eventList;
        if (selectedEvents && selectedEvents.length > 0) {
            filteredList = filteredList.filter((item) => {
                return selectedEvents.some((selectedType: any) => item?.disciplineType === selectedType);
            });
        }

        if (fromDate) {
            const FromDate = moment(fromDate).startOf("day").valueOf();
            filteredList = filteredList.filter((item) => {

                const startDate = moment(item?.startDate).startOf("day").valueOf();
                return startDate === FromDate;
            });
        }

        console.log(filteredList)
        return filteredList;
    }

    const eventTypeProps: ISelectProps = {
        classNames: `eq-multiSelect eq-searchSelect`,
        placeholder: t("events"),
        extraHeight: true,
        mode: "multiple",
        isTag: false,
        defaultSelectedValue: selectedEvents ? selectedEvents : [],
        options: eventsOptions,
        changeFunc: (value: any) => {
            console.log(value);
            setSelectedEvents(value);
        },
    };
    const createEventList = () => {
        var eventTypes = [];
        eventTypes.push({
            key: EqDisciplineType.Dressage,
            value: EqDisciplineType[EqDisciplineType.Dressage],
        });
        eventTypes.push({
            key: EqDisciplineType.Jumping,
            value: EqDisciplineType[EqDisciplineType.Jumping],
        });
        eventTypes.push({
            key: EqDisciplineType.Western,
            value: EqDisciplineType[EqDisciplineType.Western],
        });
        eventTypes.push({
            key: EqDisciplineType.Eventing,
            value: EqDisciplineType[EqDisciplineType.Eventing],
        });
        eventTypes.push({
            key: EqDisciplineType.MountedGames,
            value: EqDisciplineType[EqDisciplineType.MountedGames],
        });
        eventTypes.push({
            key: EqDisciplineType.IslandicHorses,
            value: EqDisciplineType[EqDisciplineType.IslandicHorses],
        });
        eventTypes.push({
            key: EqDisciplineType.Racehorse,
            value: EqDisciplineType[EqDisciplineType.Racehorse],
        });
        setEventsOptions(eventTypes);
        console.log("options", eventsOptions);
    };

    const handleOk = () => {
        sendReminder();
        setIsModalOpen(false);
    };

    const sendReminder = async () => {
        try {
            const data = {
                ...reminderText,
            };

            if (data.recipientEmails.length === 0) {
                return; // No need to proceed if no recipients
            }

            const response = await Api.post(ApiEndpoints.SendReminder, data);

            if (response && response.status === 200) {
                openNotificationWithIcon(
                    "Reminder Sent!",
                    "You have sent a reminder to students",
                    eqNotificationTypes.success
                );
            } else {
                throw new Error("Server error");
            }
        } catch (error) {
            openNotificationWithIcon(
                "Server error",
                "Error occurred while sending a reminder. Please try again or contact the administrator."
            );
        }
    };
    const showReminderModal = (userEmail: any) => {
        setIsModalOpen(true);
        let heading = "";
        let uniqueEmails: Set<string> = new Set();
        let message = "";
        let subject = "";

        heading = t("paymentReminder");
        subject = t("paymentReminder");
        // message = `You have unpaid orders Available .
        //         Please log in to Equinet to pay.
        //         `;
        uniqueEmails.add(userEmail);

        // setEmails(Array.from(uniqueEmails));
        // setSelectedEmails(Array.from(uniqueEmails));

        setReminderText({
            ...reminderText,
            subject: subject,
            message: message,
            heading: heading,
            recipientEmails: [userEmail],
        });
    };

    const handleShowMessageModal = (email: string) => {
        setSelectedEmail(email);
        setIsMessageModalOpen(true);
    };

    const handleCloseMessageModal = () => {
        setIsMessageModalOpen(false);
    };

    const handleSendMessage = async (data: any) => {
        try {
            const response = await Api.post(ApiEndpoints.UserMessage.SendMessageToEmail, data);

            if (response.status === 200) {
                openNotificationWithIcon(
                    t("sent"),
                    t("successfullySentMessage"),
                    eqNotificationTypes.success
                );
            } else {
                console.error("Unexpected response status:", response.status);
            }
            handleCloseMessageModal();
        } catch (error) {
            openNotificationWithIcon(
                t("error"),
                t("errorOccurredSending"),
                eqNotificationTypes.error
            );
            handleCloseMessageModal();
        }
    };

    const acceptTrainingRequest = async (event: any) => {
        try {
            
            const response = await Api.post(
                ApiEndpoints.TrainingRequest.AcceptStudentTrainingRequest,
                {
                    key: event.eventKey,
                    email: event.user.email,
                }
            );

            if (response && response.status === 200) {
                console.log("Accepted Successfully", event);

                // Optionally, you can update the state or perform other actions here
                // For example, remove the accepted event from the existing list
                console.log(trainingInvites);
                GetAllTrainingJoinRequestsByStudents();
                // setPendingTrainingInvites((prevInvites:any) =>
                //     prevInvites.filter((invite:any) => invite.eventKey !== event.eventKey)
                // );

                // If you need to set steps or other states, you can do it here
                // setSteps(3);
            } else {
                setMessageString("Failed to accept the request");
            }
        } catch (err) {
            console.error("Error accepting student training request:", err);
        }
    };

    const rejectTriningInvite = async (event: any) => {
        try {
            const response = await Api.post(
                ApiEndpoints.TrainingRequest.RejectStudentTrainingRequest,
                {
                    key: event.eventKey,
                    email: event.user.email,
                }
            );

            if (response && response.status === 200) {
                console.log("Rejected Successfully", event);

                GetAllTrainingJoinRequestsByStudents();

                // // Optionally, you can update the state or perform other actions here
                // // For example, remove the rejected event from the existing list
                // setPendingTrainingInvites((prevInvites:any) =>
                //     prevInvites.filter((invite:any) => invite.eventKey !== event.eventKey)
                // );

                // If you need to set steps or other states, you can do it here
                // setSteps(5);
            } else {
                setMessageString("Failed to reject the request");
            }
        } catch (err) {
            console.error("Error rejecting student training request:", err);
        }
    };

    return (
        <Spin size="large" spinning={loading}>
            <AnimationDiv>
                <div className="eq-sc-dash-container">
                    <div className="eq-container-fluid">
                        <Row className="eq-sb-heading-row">
                            <Col className="eq-sb-col" flex="auto" md={5} xs={24} sm={24}>
                                <h2 className="eq-sb-heading">{t("myDashboard")}</h2>
                            </Col>
                        </Row>

                        <Row gutter={6} className="cards-stylings">
                            <Col
                                xs={24}
                                lg={10}
                                // className="stats-card"
                            >
                                {<EarningsStats Earnings={schoolEarnings} />}

                                {/* <TrainerDashboardStats
                              Earnings={schoolEarnings }
                          />  */}
                            </Col>
                            <Col sm={24} lg={14} className="upcomingAct-card">
                                <UpcomingActDashboard
                                    Trainings={upcomingActivities}
                                    TrainingHeading={t("upcomingActivities")}
                                    user="school"
                                />
                            </Col>
                        </Row>

                        <Row gutter={6} className="cards-stylings">
                            <Col
                                xs={24}
                                lg={15}
                                // className="upcoming-activity-container"
                            >
                                <HorseUpcomingAct />
                            </Col>
                            <Col
                                xs={24}
                                lg={9}
                                //  className="invitation-card-container"
                            >
                                <SchoolDashboardInvitations
                                    TrainingInvitratoin={trainingInvites}
                                    onAcceptTrainingInvitations={acceptTrainingRequest}
                                    onRejectTrainingInvite={rejectTriningInvite}
                                    courseRequests={courseInvites}
                                    // onAcceptCourseInvitations={acceptCourseInvite}
                                    // onRejectCourseInvite={rejectCourseInvite}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <EqDashboardCalendar
                                    isOwner={true}
                                    trainings={schoolTrainings}
                                    events={schoolEvents}
                                    horsesList={horsesList}
                                    // selectFun={undefined}
                                    courses={courseList}
                                />
                            </Col>
                        </Row>

                        {/* <div className="eq-section">
            <EqOverviewSchoolProfile
              stat={stateView}
              trainingList={schoolTrainings}
            />
          </div> */}
                        {/* <div className="eq-section">
          <Row className="eq-db-row" align="stretch">
            <Col xs={24} sm={24} md={18} className="eq-db-icons">

              <Row>
                <div className="eq-db-h2">{t("quickLinks")}</div>
              </Row>
              <Row align="bottom" justify="start" className="eq-db-icon-row">
                <Col className="eq-db-icon" xs={8} sm={8} md={4}>
                  <Link
                    to={FrontEndPoints.school.studentBoard}
                    state={{ prevPath: location.pathname }}
                  >
                    <span>
                      <img alt="" src="/studentplus.svg" />
                    </span>
                    <div className="eq-db-icon-text">{t("inviteStudent")}</div>
                  </Link>
                </Col>
                <Col className="eq-db-icon" xs={8} sm={8} md={4}>
                  <Link
                    to={FrontEndPoints.school.activityBoard}
                    state={{ prevPath: location.pathname }}
                  >
                    <span>
                      <img alt="" src="/calendarplus.svg" />
                    </span>
                    <div className="eq-db-icon-text">
                      {t("createActivities")}
                    </div>
                  </Link>
                </Col>
                <Col className="eq-db-icon" xs={8} sm={8} md={4}>
                  <div onClick={GetStripeDashboardUrlAsync}>
                    <span>
                      <img alt="" src="/profile.svg" />
                    </span>
                    <div className="eq-db-icon-text">{t("stripeDashboard")}d</div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div> */}


                    {/* commenting because now we have separate  page for requests  */}
                    {/* {trainingInvitation ? (
            <>
              <div className="eq-section-divider"></div>
              <div className="eq-section">
                <EqCollapsePanel
                  header={t("trainingJoinRequests")}
                  children={
                    <div>
                      <EqTrainerTrainingJoinRequestBoard
                        onloadActivity={(e: any) => {
                          setTrainingInvitation(e);
                        }}
                      />
                    </div>
                  }
                />
              </div>
            </>
          ) : (
            ""
          )} */}

                    {/* <div className="eq-section-divider"></div>
          <div className="eq-section">
            <EqCollapsePanel
              header={t("newMessages")}
              children={
                <>
                  <Row className="eq-msg-header" align="bottom">
                    <Col flex="auto">
                      <div className="eq-db-h2-collapse">{t("newMessages")}</div>
                    </Col>
                    <Col md={2}>
                      <Row>
                        <Col
                          className="eq-msg-icons"
                          onClick={readSelectedMessages}
                        >
                          <span>
                            <img alt="" src="/black-check.svg" />
                          </span>
                        </Col>
         
                        <Col
                          className="eq-msg-icons"
                          onClick={deleteSelectedMessages}
                        >
                          <span>
                            <img alt="" src="/trash-alt.svg" />
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {messages.length > 0 && (
                    <>
                      {
                        <Row className="eq-list-header hidden-sm">
                          <Col md={22} flex="auto">
                            <Row>
                              <Col span={1} className="">
                                <Checkbox
                                  onChange={messagesCheckAll}
                                  checked={misCheckAll}
                                ></Checkbox>
                              </Col>
                              <Col span={3} className="">
                                {t("type")}
                              </Col>
                              <Col span={5} className="">
                                {t("type")}
                              </Col>
                              <Col flex="auto" className="">
                                {t("messageTitle")}
                              </Col>
                            </Row>
                          </Col>
                          <Col xs={4} sm={4} md={2} className="">
                            {t("action")}
                          </Col>
                        </Row>
                      }

                      {messages.map((item: IEqMessage, index: number) => (
                        <EqMessage key={index} {...item}></EqMessage>
                      ))}
                    </>
                  )}
                </>
              }
            />
          </div> */}

                        {/* <div className="eq-section-divider"></div> */}

                        {/* <div className="eq-section eq-section-training">
            <Skeleton loading={!schoolTrainings} active></Skeleton>
            <Row>
              {schoolTrainings && schoolTrainings.length > 0 && (
                ////-------------------//
                <Col span={24}>
                  <EqCollapsePanel
                    defaultOpen
                    header={t("trainings")}
                    children={
                      <div>
                        <Row gutter={[16, 16]} className="eq-section-training-filter">
                          <Col xs={24} md={8}>
                            <EqSelect {...trainingTypeProps}></EqSelect>
                          </Col>
                          <Col xs={24} md={8}>
                            <DatePicker
                              placeholder={t("selectDate")}
                              className="eq-filter-date eq-input-info"
                              onChange={(date) => setFromDate(date)}
                              value={fromDate && fromDate.isValid() ? fromDate : null}

                                                        />
                                                    </Col>
                                                    <Col xs={24} md={8}>
                                                        <EqButton classNames="btn-background-white btn-border-text-orange eq-filter-btn">
                                                            <FontAwesomeIcon icon={faFilter} className="eq-filter-btn-icon" />
                                                            {t("filter")}
                                                        </EqButton>
                                                    </Col>
                                                </Row>
                                                <EqSchoolTrainingListDashbord
                                                    trainingList={filterTrainings(schoolTrainings)}
                                                    trainersOptions={trainersOptions}
                                                    eventTypes={eventTypes}
                                                    productOptions={productOptions.editOptions}
                                                    products={products}
                                                    areas={areas || []}
                                                    weekDays={weekDays}
                                                    population={population}
                                                    groupPopulation={groupPopulation}
                                                    schoolStudents={schoolStudents}
                                                    studentHorsesList={studentHorsesList}
                                                    removeEventFunc={removeTraining}
                                                    editEventFunc={editTraining}
                                                    onCreateOrUpdateSchoolTraining={handleOnUpdateSchoolTraining}
                                                ></EqSchoolTrainingListDashbord>
                                            </div>
                                        }
                                    />

                </Col>
              )}
            </Row>
          </div> */}
                        {/* <div className="eq-section-divider"></div> */}
                        {/* 
          <div className="eq-section eq-section-training">
            <Skeleton loading={!schoolEvents} active></Skeleton>

                        <Row>
                            {schoolEvents && schoolEvents?.length > 0 && (
                                ////-------------------//
                                <Col span={24}>
                                    <EqCollapsePanel
                                        defaultOpen
                                        header={t("events")}
                                        children={
                                            <div>
                                                <Row gutter={[16, 16]} className="eq-section-training-filter">
                                                    <Col xs={24} md={8}>
                                                        <EqSelect {...eventTypeProps}></EqSelect>
                                                    </Col>
                                                    <Col xs={24} md={8}>
                                                        <DatePicker
                                                            placeholder={t("selectDate")}
                                                            className="eq-filter-date eq-input-info"
                                                            onChange={(date) => setFromDate(date)}
                                                            value={fromDate && fromDate.isValid() ? fromDate : null}
                                                        />
                                                    </Col>
                                                    <Col xs={24} md={8}>
                                                        <EqButton classNames="btn-background-white btn-border-text-orange eq-filter-btn">
                                                            <FontAwesomeIcon icon={faFilter} className="eq-filter-btn-icon" />
                                                            {t("filter")}
                                                        </EqButton>
                                                    </Col>
                                                </Row>
                                                <EqActivityListSchoolDashboard
                                                    eventList={filterEvents(schoolEvents)}
                                                    areas={areas}
                                                    weekDays={weekDays}
                                                    population={population}
                                                    groupPopulation={groupPopulation}
                                                    trainerStudents={schoolStudents}
                                                    studentHorsesList={studentHorsesList}
                                                    removeEventFunc={removeEvent}
                                                    // editEventFunc= editEvent
                                                    // onCreateOrUpdateActivity={trainerEventDefaults}
                                                    onCreateOrUpdateActivity={handleOnUpdateSchoolEvent}
                                                ></EqActivityListSchoolDashboard>
                                            </div>}
                                    />


                </Col>
              )}
            </Row>
          </div> */}
                    </div>
                </div>
            </AnimationDiv>

            <UnpaidOrdersModalSchool
                isModalVisible={isModalVisible}
                handleCancel={handleCancel}
                unpaidOrders={unpaidOrders}
                handleShowMessageModal={handleShowMessageModal}
                showReminderModal={showReminderModal}
            />

            <Modal
                className="send-reminder-modal"
                title={reminderText.heading}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleClose}
                okText={t("sendReminder")}
                cancelText={t("cancel")}
                width={"85vw"}
            >
                {/* <h4>{t("to")}</h4> */}
                {/* <EqSelect {...searchProps}></EqSelect> */}

                <h4>{t("message")}</h4>
                <textarea
                    className="send-mail-input"
                    value={reminderText.message}
                    onChange={(e) => setReminderText({ ...reminderText, message: e.target.value })}
                    rows={4}
                />
            </Modal>

            <EqSendMessageModal
                visible={isMessageModalOpen}
                recipientEmail={selectedEmail}
                onCreate={handleSendMessage}
                onCancel={handleCloseMessageModal}
            />
        </Spin>
    );
};

export default EqSchoolDashboard;
